import { Uuid } from "@/domains/global/identifiers";
import { UuidNamespace } from "@/modules/uuid/constants";
import { v5 as uuidv5 } from "uuid";

/**
 * Generate a deterministic UUID for ConnectedCalendar based on the
 * CalendarConnection ID and the external calendar ID from the provider.
 *
 * This matches the backend's resolve_connected_calendar_uuid function.
 *
 * @param calendarConnectionId - The SpaceAccountCalendarConnection ID
 * @param externalCalendarId - The provider's stable calendar identifier (e.g., Google calendar ID)
 * @returns Deterministic UUID for the ConnectedCalendar
 */
export const resolveConnectedCalendarUuid = ({
  calendarConnectionId,
  externalCalendarId,
}: {
  calendarConnectionId: string;
  externalCalendarId: string;
}): Uuid => {
  const upperCalendarConnectionId = calendarConnectionId.toUpperCase();
  const upperExternalCalendarId = externalCalendarId.toUpperCase();
  const name = `${upperCalendarConnectionId}::${upperExternalCalendarId}`;
  return uuidv5(name, UuidNamespace.SyncModelNamespace);
};
